import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "graphql-tag";
import { navigate, RouteComponentProps } from "@reach/router";
import logger from "services/logger";
import { newList } from "types/gql-types";
import styles from "../adminDashboard.module.css";
import ListsForm, { InterestList } from "./form";

const CREATE_LIST = gql`
  mutation newList($data: InterestListInput!) {
    createInterestList(data: $data) {
      id
    }
  }
`;

const initialData = {
  organizationId: "",
  name: "",
  type: "",
  email: "",
  phone: "",
  hasPaperDisclaimer: false,
  address: {
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  },
};


const NewList: React.FC<RouteComponentProps> = () => {
  const [sending, setSending] = React.useState(false);
  const [createInterestList] = useMutation<newList>(CREATE_LIST);
  const submitForm = (formData: InterestList) => {
    setSending(true);
    createInterestList({ variables: { data: formData } })
      .then(() => navigate("/dash/admin/lists"))
      .catch((err) => {
        logger.sendError(err);
        setSending(false);
      });
  };
  return (
    <div className="card">
      <h1 className={`${styles.heading}`}>Create a List</h1>

      <ListsForm
        formType="new"
        initialData={initialData}
        sending={sending}
        handleSubmit={submitForm}
      />
    </div>);
};

export default NewList;
